import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { InputDiscriminators, InputType, QuestionDefinition } from './form.types';

@Injectable({
    providedIn: 'root'
})
export class QuestionStateService {
    constructor() {}

    private inputStateSubject: Subject<InputState> = new Subject<InputState>();
    public inputStateObservable = this.inputStateSubject.asObservable();
    private questionStateSubject: Subject<QuestionState> = new Subject<QuestionState>();
    public questionStateObservable = this.questionStateSubject.asObservable();
    sendToInput(state: InputState) {
        this.inputStateSubject.next(state);
    }

    sentToQuestion(state: QuestionState) {
        this.questionStateSubject.next(state);
    }

    generateUniqueId(element: any, property: string, typeName: string) {
        if (!element) {
            return `new_${typeName}`;
        }
        return `${typeName}_${element[property]}`;
    }
}

export interface InputState {
    input: InputType;
    updates: {
        [key: string]: any;
    };
}

export interface QuestionState {
    question: QuestionDefinition;
    updates?: {
        [key: string]: any;
    };
    regeneratePrompts?: boolean;
}
